import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-us">
      <div className="about-hero">
        <div className="container">
          <h1>About Milestone Construction Services Co</h1>
          <p>Your vision, our precision</p>
        </div>
      </div>

      <div className="about-content">
        <div className="container">
          {/* Company Overview */}
          <section className="company-overview">
            <h2>Our Story</h2>
            <p>
              Milestone Construction Services Co has been a trusted name in the construction industry for over 10 years. 
              We specialize in residential and commercial construction, renovation, and remodeling projects. 
              Our team of skilled professionals is committed to delivering exceptional results that exceed 
              our clients' expectations.
            </p>
            <p>
              From initial concept to final completion, we work closely with our clients to ensure every 
              project reflects their vision while maintaining the highest standards of quality and safety. 
              Our dedication to excellence and customer satisfaction has made us a preferred choice for 
              construction projects throughout the region.
            </p>
          </section>

          {/* Statistics */}
          <section className="stats-section">
            <h2>Our Achievements</h2>
            <div className="stats-grid">
              <div className="stat-card">
                <h3>500+</h3>
                <p>Projects Completed</p>
              </div>
              <div className="stat-card">
                <h3>10+</h3>
                <p>Years Experience</p>
              </div>
              <div className="stat-card">
                <h3>100%</h3>
                <p>Client Satisfaction</p>
              </div>
            </div>
          </section>

          {/* Why Choose Us */}
          <section className="why-choose-section">
            <h2>Why Choose NJ-MCS?</h2>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">⭐</div>
                <h3>Quality Assurance</h3>
                <p>We use only the finest materials and employ skilled craftsmen to ensure lasting quality.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">⏰</div>
                <h3>On-Time Delivery</h3>
                <p>Our project management expertise ensures your project is completed on schedule.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">💰</div>
                <h3>Competitive Pricing</h3>
                <p>Transparent pricing with no hidden costs - you get excellent value for your investment.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">🛡️</div>
                <h3>Licensed & Insured</h3>
                <p>Fully licensed, bonded, and insured for your peace of mind and protection.</p>
              </div>
            </div>
          </section>

          {/* Contact CTA */}
          <section className="contact-cta">
            <h2>Ready to Start Your Project?</h2>
            <p>Contact Us or Book an Appointment That Fits You Now</p>
            <div className="cta-buttons">
              <a href="/contact" className="cta-button primary">Contact Us</a>
              <a href="/services" className="cta-button secondary">View Our Services</a>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
